<template>
  <v-container v-if="showSignupForm" fluid pa-0 >
    <v-row class="mx-2" fill-height>
      <v-col cols="12" lg="8" align-self="center">
        <v-row justify="space-around">
          <v-col cols="12" lg="4">
            <img class="d-block mx-auto mb-6" src="https://www.systemx.net/wp-content/uploads/2023/08/systemX.svg" />
            <email-verification v-if="!emailIsVerified" :token="token"  @emailVerified="onEmailVerified" :otp="otp" />
            <sign-up-form v-else :email-verification-data="emailVerificationData" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="0" lg="4" style="background-color: #f6f7f9" class="d-flex justify-center align-center">
        <img src="https://www.systemx.net/wp-content/uploads/2023/08/Layer_1.png"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EmailVerification from '@/components/EmailVerification.vue';
import SignUpForm from '@/components/SignUpForm.vue';
export default {
  components: {
    EmailVerification,
    SignUpForm
  },
  data() {
    return {
      showSignupForm: false,
      emailVerificationData: null,
      token: '',
      otp: '',
    };
  },
  computed: {
    emailIsVerified() {
      return this.emailVerificationData !== null;
    }
  },
  beforeRouteEnter(to, _, next) {
    if (to.query && to.query.token) {
      next(vm => vm.init(to.query.token, to.query.otp || null));
    } else {
      window.location.href = 'https://systemx.net';
    }
  },
  created() {
    this.$api.setCoreUrl();
  },
  methods: {
    async init(token, otp = null) {
      this.showSignupForm = true;
      this.token = token;

      if (otp !== null) this.otp = otp || '';
    },
    onEmailVerified(data) {
      if (!data || !data.emailVerificationId) return;
      this.emailVerificationData = data;
    }
  },
};
</script>

<style lang="scss">

</style>
